import { Button } from 'blaze-ui/Button'
import { Heading } from 'blaze-ui/Heading/Heading'
import { Text } from 'blaze-ui/Text/Text'
import Styles from './DiscountApplied.module.scss'
import { Modal } from 'almanac-ui/Modal'
import { useOpenSettings } from 'hooks/useOpenSettings'
import { SettingScreen } from 'components/Settings/types'

interface Props {
  onClose: () => void
}

export const DiscountApplied = ({ onClose }: Props) => {
  const { openSettings } = useOpenSettings()

  const handleClose = () => {
    onClose()
    openSettings(SettingScreen.Billing)
  }

  return (
    <div>
      <Modal.Header title="Discount applied" onClose={handleClose} />
      <div className={Styles.header}>
        <Heading level={2}>
          Great choice! Your discount is active.
        </Heading>
      </div>
      <div className={Styles.content}>
        <Text variant="primary" color="var(--dark-80)">
          You'll see the discount reflected on your next invoice in Billing.
        </Text>
      </div>
      <div className={Styles.divider} />
      <div className={Styles.footer}>
        <Button size="lg" onPress={handleClose}>
          Close
        </Button>
      </div>
    </div>
  )
}
